import React, { useState, useEffect } from "react";
import AsyncSelect from "react-select/async";
import "./Search.css";
function Search() {
  // constants
  const [isSignIn, setIsSignIn] = useState(
    localStorage.getItem("isSignIn") === "true" || false
  );
  const [email, setEmail] = useState(localStorage.getItem("email") || "");
  const [username, setUsername] = useState(
    localStorage.getItem("username") || ""
  );
  const [isLoading, setIsLoading] = useState(false);

  const [selectedIngredients, setSelectedIngredients] = useState([]);
  const [recipesArray, setRecipesArray] = useState([]);

  const jumpToHome = () => {
    window.location.href = "/Home";
  };
  const loadOptions = async (inputValue, callback) => {
    if (inputValue.length < 3) {
      return;
    }
    try {
      const res = await fetch(
        `https://api.edamam.com/api/food-database/v2/parser?ingr=${inputValue}&app_id=28692970&app_key=b18bc309cd3ea587e3e616709a1617f0`
      );
      const data = await res.json();
      if (data.hints.length > 0) {
        const ingredients = data.hints.map((hint) => ({
          value: hint.food.label,
          label: hint.food.label,
        }));
        const filteredIngredients = ingredients.filter(
          (ingredient) =>
            !selectedIngredients.find(
              (selected) => selected.value === ingredient.value
            )
        );
        callback(filteredIngredients);
      }
    } catch (error) {
      console.error("Failed to search ingredients:", error);
    }
  };
  const handleRecipeSearch = async (event) => {
    if (selectedIngredients.length === 0) {
      alert("Please add at least one ingredient");
      return;
    }
    event.preventDefault();
    setIsLoading(true);

    const ingredients = selectedIngredients.map(
      (ingredient) => ingredient.value
    );
    try {
      const res = await fetch(
        `https://6fx3o6vq5ow5yeeogb35xpbnly0ekeci.lambda-url.ca-central-1.on.aws?prompt=${ingredients.join(
          ","
        )}`,

        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = await res.json();
      if (data) {
        const dishes = data
          .split("\n")
          .filter((item) => item.trim() !== "") // Filter out any empty lines
          .map((item) => item.replace(/[0-9.]/g, "").trim()); // Remove numbers and periods, then trim

        setRecipesArray(dishes);
        console.log(dishes);
      } else {
        console.log("No recipes found");
      }
    } catch (error) {
      console.error("Failed to search recipes:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleIngredientChange = (newValue) => {
    setSelectedIngredients((prevIngredients) => [...prevIngredients, newValue]);
  };
  const handleDeleteIngredient = (indexToDelete) => {
    const newSelectedIngredients = selectedIngredients.filter(
      (_, index) => index !== indexToDelete
    );
    setSelectedIngredients(newSelectedIngredients);
  };

  // useEffects
  useEffect(() => {
    localStorage.setItem("isSignIn", isSignIn);
  }, [isSignIn]);
  useEffect(() => {
    localStorage.setItem("email", email);
  }, [email]);
  useEffect(() => {
    localStorage.setItem("username", username);
  }, [username]);

  // return statement
  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          <div className="navbar-logo">
            <h1>Chef's Kiss</h1>
          </div>
          <div className="navbar-user">
            <button
              className="btn btn-user"
              onClick={() => {
                jumpToHome();
              }}
            >
              Home
            </button>
            <button
              className="btn btn-logout"
              onClick={() => {
                setIsSignIn(false);
                setEmail("");
                setUsername("");
                window.location.href = "/";
              }}
            >
              Logout
            </button>
          </div>
        </div>
      </nav>
      <div className="search-container">
        <div className="Ingredients-search">
          {isLoading ? (
            <div className={`loader-overlay ${isLoading ? "active" : ""}`}>
              <div className="loader-text">Cooking the recipe ...</div>
              <div className="loader" />
            </div>
          ) : (
            <>
              <h1>Dish Searcher</h1>
              <div className="search">
                <AsyncSelect
                  cacheOptions // Enable caching
                  defaultOptions // Load default options on component load
                  placeholder="Enter an ingredient to add it to the list of ingredients"
                  loadOptions={loadOptions}
                  onChange={handleIngredientChange}
                />
              </div>
              <button className="submit-btn" onClick={handleRecipeSearch}>
                Search
              </button>
              {selectedIngredients.length > 0 && (
                <div className="ingredient-basket">
                  <h2>Your Ingredients:</h2>
                  <ul>
                    {selectedIngredients.map((ingredient, index) => (
                      <li key={index}>
                        {ingredient.value}
                        <button onClick={() => handleDeleteIngredient(index)}>
                          Delete
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              {recipesArray.length > 0 && (
                <div className="dishes-list">
                  <h2>Found Dishes:</h2>
                  <ul>
                    {recipesArray.map((dish, index) => (
                      <div className="list-li">
                        <li key={index}>{dish}</li>
                        <button
                          onClick={() => {
                            localStorage.setItem("dish", dish);
                            window.location.href = "/chatgpt";
                          }}
                        >
                          Make Recipe
                        </button>
                        <a
                          href="https://www.google.com/search?q={dish}"
                          target="_blank"
                        >
                          Search Recipe
                        </a>
                      </div>
                    ))}
                  </ul>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}
export default Search;
